import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DemoTileViewModel } from "../core/model/ContentManagement";

@Injectable({
  providedIn: "root"
})
export class CollectionService {
  private collectionSubject = new BehaviorSubject<DemoTileViewModel[]>([]);
  collection$ = this.collectionSubject.asObservable();

  constructor() {}

  addToCollection(demoTile: DemoTileViewModel): void {
    this.collectionSubject.next([...this.collectionSubject.value, demoTile]);
  }

  removeFromCollection(demoTile: DemoTileViewModel): void {
    const currentValues = [...this.collectionSubject.value];
    const demoTileIndex = currentValues.findIndex(x => x.id === demoTile.id);
    currentValues.splice(demoTileIndex, 1);

    this.collectionSubject.next(currentValues);
  }

  resetCollection(): void {
    this.collectionSubject.next([]);
  }
}
